import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@material-ui/core';
import { Colors } from '@auteco/theme';
import useStyles from '../styles';

const TableToolbar = ({ onAssignMaterials, onExportMaterial, idSaved, refreshData }) => {
  const classes = useStyles();

  return (
    <>
      <Button
        variant="contained"
        style={{
          backgroundColor: Colors.BLUE,
          color: '#98e2f0',
          marginTop: '20px'
        }}
        className={classes.assignBtn}
        onClick={onAssignMaterials}
      >
        Finalizar materiales seleccionados ✅
      </Button>
      
      <Button
        variant="contained"
        style={{
          backgroundColor: Colors.BLUE,
          color: '#98e2f0',
          marginTop: '20px',
          marginLeft: '20px'
        }}
        className={classes.assignBtn}
        onClick={() => onExportMaterial(idSaved)}
      >
        Exportar a Excel 📊
      </Button>

      {idSaved && (
        <p
          style={{
            margin: '20px',
            fontSize: '20px',
            textAlign: 'center',
            cursor: 'pointer'
          }}
          onClick={refreshData}
        >
          🔄
        </p>
      )}
    </>
  );
};

TableToolbar.propTypes = {
  onAssignMaterials: PropTypes.func.isRequired,
  onExportMaterial: PropTypes.func.isRequired,
  idSaved: PropTypes.string,
  refreshData: PropTypes.func.isRequired
};

TableToolbar.defaultProps = {
  idSaved: null
};

export default TableToolbar;
